import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tab-preferences',
  templateUrl: './tab-preferences.component.html',
  styleUrls: ['./tab-preferences.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabPreferencesComponent {
  @Input() public preferencesForm: FormGroup;
  public imageChangedEvent: string;
  public croppedImage: string;
  public size: number;

  constructor() { }
}
